<template>
  <div>
    <lottie :options="defaultOptions" :height="100" :width="100" v-on:animCreated="handleAnimation"></lottie>
  </div>
</template>
<script>
import Lottie from 'vue-lottie';
import * as animationData from '../assets/loading_animation.json';
export default {
  name: 'loading',
  components: { Lottie },
  data () {
    return {
      defaultOptions: { animationData: animationData.default, renderer: 'svg',
        loop: true,
        autoplay: true, },
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>

</style>

